<template>
  <div class="machine-group">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-hasPerm="['machine:group:insert']"
          @click="addMachineGroup"
          style="margin: 0"
          >{{ $t("common.add") }}</el-button
        >
      </div>
      <div class="el-right">
        <el-form
          ref="machineGroup"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="name" style="margin-bottom: 0">
            <el-input v-model="search.name" :placeholder="$t('machineGroup.name')"></el-input>
          </el-form-item>
          <el-form-item style="margin: 0">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
            <el-button @click="resetSearch('machineGroup')" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="machineGroupList"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column type="selection" width="40" :align="'center'"></el-table-column>
        <el-table-column
          prop="name"
          :show-overflow-tooltip="true"
          :label="$t('machineGroup.name')"
          width="250"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="notes" :label="$t('machineGroup.notes')"></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('machineGroup.createTime')"
          :align="'center'"
          width="170px"
        ></el-table-column>
        <el-table-column fixed="right" :label="$t('common.operate')" :align="'center'" min-width="280">
          <template slot-scope="scope">
            <el-button size="mini" v-hasPerm="['machine:group:update']" @click="editMachine(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button
              type="warning"
              v-hasPerm="['machine:group:move:group']"
              size="mini"
              @click="transferMachine(scope.row)"
              >{{ $t("machineGroup.transfer") }}</el-button
            >
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handlerDelete(scope.row)">{{
              $t("admin.MachineGroup.168906-0")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="machineGroupList.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="+page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="machineGroup.id ? $t('machineGroup.edit') : $t('machineGroup.add')"
      :visible.sync="dialogMachineGroup"
      width="35%"
      top="9vh"
      @closed="closeDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form
          :label-position="labelPosition"
          :rules="rules"
          ref="machineGroup"
          label-width="80px"
          :model="machineGroup"
        >
          <el-form-item :label="$t('machineGroup.name')" prop="name">
            <el-input v-model="machineGroup.name" :placeholder="$t('machineGroup.pName')" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('admin.MachineGroup.389942-0')" prop="shippingOrderId">
            <el-select
              v-model="machineGroup.shippingOrderId"
              :placeholder="$t('admin.MachineGroup.389942-1')"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="order in shippingOrderList"
                :key="order.id"
                :label="order.orderNo || order.name || order.id"
                :value="order.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('machineGroup.notes')" style="margin-bottom: 0">
            <el-input type="textarea" :rows="4" v-model="machineGroup.notes"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('machineGroup')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
    <transfer-machine
      v-on:cancelTransferMachine="cancelTransferMachine"
      @quicklyCreateAccount="quicklyCreateAccount"
      :machineType="machineType"
      :appTypeList="appTypeList"
      :teamId="teamId"
      :dialogTransferMachine="dialogTransferMachine"
    >
    </transfer-machine>
    <!-- 新建账号 -->
    <add-user
      :userTypeList="userTypeList"
      :timeZoneList="timeZoneList"
      :countryList="countryList"
      v-on:cancel="addUserCancel"
      :dialogAddUser="dialogAddUser"
      :userForm="userForm"
    >
    </add-user>
  </div>
</template>

<script>
  import transferMachine from "_c/machine/admin/TransferMachine";
  import addUser from "_c/system/user/AddUser";

  export default {
    name: "MachineGroup",
    components: {
      transferMachine,
      addUser
    },
    data() {
      return {
        search: {
          name: ""
        },
        machineGroup: {
          id: "",
          name: "",
          notes: "",
          shippingOrderId: ""
        },
        shippingOrderList: [],
        multipleSelection: [],
        loading: false,
        machineGroupList: [],
        dialogMachineGroup: false,
        dialogTransferMachine: false,
        labelPosition: "top",
        teamId: "",
        rules: {
          name: [
            {
              required: true,
              message: this.$t("machineGroup.pName"),
              trigger: "blur"
            }
          ],
          shippingOrderId: [
            {
              required: true,
              message: this.$t('admin.MachineGroup.389942-1'),
              trigger: "change"
            }
          ]
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        loadingForm: false,
        // 引入新建账号
        dialogAddUser: false,
        userForm: {
          id: "",
          userName: "",
          nickName: "",
          passWord: "",
          checkPassword: "",
          email: "",
          timeZone: "",
          phone: "",
          roleId: "",
          notes: ""
        },
        userTypeList: [],
        timeZoneList: [],
        countryList: [],
        machineType: [],
        appTypeList: []
      };
    },
    mounted() {
      this.currentChange();
      this.listUserType();
      this.listTimeZone();
      this.listCountry();
      this.listShippingOrder();
    },
    methods: {
      handlerDelete(group) {
        this.$confirm(this.$t("admin.MachineGroup.168906-1"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.MachineGroup.delete, this.$method.delete, {
              id: group.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("machineGroup.deleteSuccess"),
                  type: "success"
                });
                this.currentChange(this.page.pageIndex);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        });
      },
      // add user
      quicklyCreateAccount() {
        this.dialogAddUser = true;
      },
      listUserType() {
        this.$api
          .request(this.$url.User.getByList, this.$method.get, {})
          .then(res => {
            if (res.code == 0) {
              this.userTypeList = res.data;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      listTimeZone() {
        this.$api.dict("gp_time_zone").then(res => {
          if (res.code === 0) {
            this.timeZoneList = res.data;
          }
        });
      },
      listCountry() {
        this.$api.dict("gp_country_list").then(res => {
          if (res.code === 0) {
            this.countryList = res.data;
          }
        });
      },
      addUserCancel() {
        this.dialogAddUser = false;
        this.$toolUtil.clearForm(this.userForm);
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.MachineGroup.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.machineGroupList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 获取订单列表
      listShippingOrder() {
        this.$api
          .request(this.$url.ShippingOrder.list, this.$method.get, {})
          .then(res => {
            if (res.code === 0) {
              this.shippingOrderList = res.data || [];
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 添加分组
      addMachineGroup() {
        this.dialogMachineGroup = true;
        // 打开对话框时重新加载订单列表
        if (this.shippingOrderList.length === 0) {
          this.listShippingOrder();
        }
      },
      // 搜索
      onSubmit() {
        this.currentChange();
      },
      // 重置搜索
      resetSearch(formName) {
        this.$refs[formName].resetFields();
        this.$toolUtil.clearForm(this.search);
        this.currentChange();
      },
      // 全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭弹框
      closeDialog() {
        this.dialogMachineGroup = false;
        this.$toolUtil.clearForm(this.machineGroup);
        this.clearValidate("machineGroup");
      },
      // 清除表单校验
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },
      // 关闭弹框
      cancel() {
        this.dialogMachineGroup = false;
      },
      // 添加分组
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            let url = this.$url.MachineGroup.insert;
            let method = this.$method.post;
            if (this.machineGroup.id) {
              url = this.$url.MachineGroup.update;
              method = this.$method.put;
            }
            this.$api
              .request(url, method, this.machineGroup)
              .then(res => {
                if (res.code === 0) {
                  this.dialogMachineGroup = false;
                  this.$notify({
                    title: this.$t("common.tip"),
                    message:
                      (this.machineGroup.id ? this.$t("machineGroup.up") : this.$t("machineGroup.save")) +
                      this.$t("machineGroup.groupS"),
                    type: "success"
                  });
                  this.currentChange(this.page.pageIndex);
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      },
      editMachine(row) {
        this.dialogMachineGroup = true;
        Object.keys(this.machineGroup).forEach(key => {
          this.machineGroup[key] = row[key];
        });
        this.machineGroup.id = row.id;
      },
      transferMachine(row) {
        this.dialogTransferMachine = true;
        this.teamId = row.id;
      },
      cancelTransferMachine(dialog, state) {
        this.dialogTransferMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      }
    }
  };
</script>

<style>
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }
  .el-dialog__footer {
    padding: 20px;
  }
</style>
